import api from "../../util/api";
import * as parametrosActions from "../../store/modules/personas/parametros_store/actions";
import { setLoading } from "../../store/modules/globalLoading/actions";
import { notifySuccess, notifyWarn } from "../../components/message/message";
import { PLATAFORMA_AGENTE_ID, PLATAFORMA_DISCADOR_ID, TIPO_INTEGRACAO_TELECOM_ID } from "../../util/constants";

export async function getTipoIntegracao() {
  const data = await api.get("TipoIntegracao");

  if (!data.success) {
    return;
  }

  parametrosActions.setItemTipoIntegracao(data.content);
}

export async function getParametrosDePara() {
  const data = await api.get("ParametrosDePara");

  if (!data.success) {
    return;
  }

  parametrosActions.setParametrosDePara(
    data.content.map((item) => {
      return {
        id: item.id,
        descricao: item.variavel,
        campoEquivalente: item.campoEquivalenteCrm,
      };
    })
  );
}

export async function getCredencial(lojaId) {
  const data = await api.get(`CredenciaisBmg/${lojaId}`);

  if (!data.success) {
    return;
  }

  parametrosActions.setCredenciais([
    {
      id: data.content.id,
      login: data.content.login,
      senha: "",
    },
  ]);
}

export async function deleteCredencial(id) {
  setLoading(true);
  const data = await api.delete(`CredenciaisBmg/${id}`);
  setLoading(false);

  if (!data.success) {
    return false;
  }

  parametrosActions.cleanAll();
  return true;
}

export async function updateCredencial(item) {
  if (item.login === "") {
    return notifyWarn("Necessário informar o login.");
  }

  if (item.senha === "") {
    return notifyWarn("Necessário informar a senha.");
  }

  const body = {
    login: item.login,
    senha: item.senha,
  };

  setLoading(true);
  const data = await api.put(`CredenciaisBmg/${item.id}`, body);
  setLoading(false);

  if (!data.success) {
    return;
  }

  notifySuccess("Credencial atualizada com sucesso!");
}

export async function createCredencial(item, lojaId) {
  if (item.login === "") {
    return notifyWarn("Necessário informar o login.");
  }

  if (item.senha === "") {
    return notifyWarn("Necessário informar a senha.");
  }

  const body = {
    login: item.login,
    senha: item.senha,
    lojaId: lojaId,
  };

  setLoading(true);
  const data = await api.post(`CredenciaisBmg/`, body);
  setLoading(false);

  if (!data.success) {
    return;
  }

  getCredencial(lojaId);

  notifySuccess("Credencial adicionada com sucesso! ");
}

export async function salveParametroIntegracao(item, tipoIntegracao, tipoLoja) {
  let body = {};
  if (tipoIntegracao.toUpperCase() === TIPO_INTEGRACAO_TELECOM_ID) {
    if (item.plataformaIntegracaoId.toUpperCase() === PLATAFORMA_DISCADOR_ID) {
      if (!item.telecom_urlDiscador) {
        return notifyWarn("Necessário informar a URL do discador.");
      }
      if (item.telecom_urlDiscador && !item.telecom_login) {
        return notifyWarn("Necessário informar o usuário do discador.");
      }

      if (item.telecom_urlDiscador && !item.telecom_senha) {
        return notifyWarn("Necessário informar a senha do discador.");
      }

      body = {
        plataformaIntegracaoId: item.plataformaIntegracaoId,
        tipoIntegracaoId: tipoIntegracao,
        lojaId: tipoLoja.id,
        url: item.telecom_urlDiscador,
        login: item.telecom_login,
        senha: item.telecom_senha,
      };
    }
    if (item.plataformaIntegracaoId.toUpperCase() === PLATAFORMA_AGENTE_ID) {
      if (!item.telecom_url) {
        return notifyWarn("Necessário informar a URL do agente.");
      }
      body = {
        plataformaIntegracaoId: item.plataformaIntegracaoId,
        tipoIntegracaoId: tipoIntegracao,
        lojaId: tipoLoja.id,
        url: item.telecom_url,
        login: item.telecom_usuarioApiAgente,
        senha: item.telecom_senhaApiAgente,
      };
    }
  } else {
    body = {
      plataformaIntegracaoId: item.plataformaIntegracaoId,
      tipoIntegracaoId: tipoIntegracao,
      lojaID: tipoLoja.id,
      url: item.url,
    };
  }
  setLoading(true);
  const data = await api.post(`ParametroIntegracao`, body);
  setLoading(false);
  if (!data.success) {
    return;
  }
  parametrosActions.setItem({
    id: "",
    login: "",
    senha: "",
    url: "",
    plataforma: "",
    plataformaIntegracaoId: "0",
    telecom_idDiscador: "",
    telecom_urlDiscador: "",
    telecom_login: "",
    telecom_senha: "",
    telecom_idAgente: "",
    telecom_url: "",
    telecom_usuarioApiAgente: "",
    telecom_senhaApiAgente: "",
    temRegistro: false,
  });
  notifySuccess("Parametro integração adicionado com sucesso! ");
}

function getParametroIntegracaoId(item, tipoIntegracaoId) {
  const TELECOM_ID = "0D7B60A9-F267-439F-B3B9-7A7504FEABEC";
  const DISCADOR_ID = "1AA46412-40C9-411E-B831-C1E8FDC18044";
  const AGENTE_ID = "BD8EDDF0-C99C-4275-B0C5-A2279CC88138";

  if (tipoIntegracaoId?.toUpperCase() === TELECOM_ID) {
    const plataforma = item.plataformaIntegracaoId?.toUpperCase();
    if (plataforma === DISCADOR_ID) return item.telecom_idDiscador;
    if (plataforma === AGENTE_ID) return item.telecom_idAgente;
  }
  return item.id;
}

export async function updateParametroIntegracao(
  item,
  tipoIntegracaoId,
  tipoLoja
) {
  let body = {};
  const id = getParametroIntegracaoId(item, tipoIntegracaoId);
  if (tipoIntegracaoId.toUpperCase() === TIPO_INTEGRACAO_TELECOM_ID) {
    if (item.plataformaIntegracaoId.toUpperCase() === PLATAFORMA_DISCADOR_ID) {
      if (!item.telecom_urlDiscador) {
        return notifyWarn("Necessário informar a URL do discador.");
      }
      if (item.telecom_urlDiscador && !item.telecom_login) {
        return notifyWarn("Necessário informar o usuário do discador.");
      }

      if (item.telecom_urlDiscador && !item.telecom_senha) {
        return notifyWarn("Necessário informar a senha do discador.");
      }

      body = {
        plataformaIntegracaoId: item.plataformaIntegracaoId,
        tipoIntegracaoId: tipoIntegracaoId,
        lojaId: tipoLoja.id,
        url: item.telecom_urlDiscador,
        login: item.telecom_login,
        senha: item.telecom_senha,
      };
    }
    if (item.plataformaIntegracaoId.toUpperCase() === PLATAFORMA_AGENTE_ID) {
      if (!item.telecom_url) {
        return notifyWarn("Necessário informar a URL do agente.");
      }
      body = {
        plataformaIntegracaoId: item.plataformaIntegracaoId,
        tipoIntegracaoId: tipoIntegracaoId,
        lojaId: tipoLoja.id,
        url: item.telecom_url,
        login: item.telecom_usuarioApiAgente,
        senha: item.telecom_senhaApiAgente,
      };
    }
  } else {
    body = {
      plataformaIntegracaoId: item.plataformaIntegracaoId,
      tipoIntegracaoId: tipoIntegracaoId,
      lojaID: tipoLoja.id,
      url: item.url,
    };
  }
  setLoading(true);
  const data = await api.put(`ParametroIntegracao/${id}`, body);
  setLoading(false);

  if (!data.success) {
    return;
  }
  parametrosActions.setItem({
    id: "",
    login: "",
    senha: "",
    url: "",
    plataforma: "",
    plataformaIntegracaoId: "0",
    telecom_idDiscador: "",
    telecom_urlDiscador: "",
    telecom_login: "",
    telecom_senha: "",
    telecom_idAgente: "",
    telecom_url: "",
    telecom_usuarioApiAgente: "",
    telecom_senhaApiAgente: "",
    temRegistro: false,
  });
  notifySuccess("Parametro integração atualizado com sucesso! ");
}

export async function GetByLojaId(tipoLojaId, tipoIntegracaoId) {
  setLoading(true);
  const data = await api.get(
    `ParametroIntegracao/${tipoLojaId}/${tipoIntegracaoId}`
  );
  setLoading(false);

  if (!data.success) {
    return;
  }

  if (data.content?.registros?.length > 0) {
    const integracoes = data.content.registros.map((registro) => {
      if (tipoIntegracaoId.toUpperCase() === TIPO_INTEGRACAO_TELECOM_ID) {
        if (registro.plataformaIntegracaoId.toUpperCase() === PLATAFORMA_DISCADOR_ID) {
          return {
            id: "",
            plataforma: registro.plataforma,
            plataformaIntegracaoId:
              registro.plataformaIntegracaoId?.toUpperCase(),
            url: registro.url,
            descricao: registro.plataforma,
            telecom_idDiscador: registro.id,
            telecom_urlDiscador: registro.url,
            telecom_login: registro.login,
            telecom_senha: registro.senha,
            telecom_idAgente: "",
            telecom_url: "",
            telecom_usuarioApiAgente: "",
            telecom_senhaApiAgente: "",
            temRegistro: true,
          };
        }
        if (registro.plataformaIntegracaoId.toUpperCase() === PLATAFORMA_AGENTE_ID) {
          return {
            id: "",
            plataforma: registro.plataforma,
            plataformaIntegracaoId:
              registro.plataformaIntegracaoId?.toUpperCase(),
            url: registro.url,
            descricao: registro.plataforma,
            telecom_idDiscador: "",
            telecom_urlDiscador: "",
            telecom_login: "",
            telecom_senha: "",
            telecom_idAgente: registro.id,
            telecom_url: registro.url,
            telecom_usuarioApiAgente: registro.login,
            telecom_senhaApiAgente: registro.senha,
            temRegistro: true,
          };
        }
      }
      return {
        id: registro.id,
        plataforma: registro.plataforma,
        plataformaIntegracaoId: registro.plataformaIntegracaoId?.toUpperCase(),
        url: registro.url,
        descricao: registro.plataforma,
        telecom_idDiscador: "",
        telecom_urlDiscador: "",
        telecom_login: "",
        telecom_senha: "",
        telecom_idAgente: "",
        telecom_url: "",
        telecom_usuarioApiAgente: "",
        telecom_senhaApiAgente: "",
        temRegistro: true,
      };
    });
    parametrosActions.setIntegracoes(integracoes);
  } else {
    parametrosActions.setIntegracoes([]);
  }
}

export async function getPlataformas() {
  const data = await api.get("Plataformas");

  if (!data.success) {
    return;
  }

  parametrosActions.setPlataformas(data.content);
}

export async function deleteIntegracao(item, tipoLojaId, tipoIntegracaoId) {
  const id = getParametroIntegracaoId(item, tipoIntegracaoId);
  setLoading(true);
  const data = await api.delete(`ParametroIntegracao/${id}`);
  setLoading(false);

  if (!data.success) {
    return false;
  }
  parametrosActions.cleanAll();
  GetByLojaId(tipoLojaId, tipoIntegracaoId);
  return true;
}
